import * as React from "react";
import { includes } from "lodash";
import { Button } from "react-bootstrap";
import "rc-tree/assets/index.css";
import Tree, { TreeNode } from "rc-tree";
import { AreaNode } from "./areaModels";

interface TProps {
  data: AreaNode[];
  onSelectionChange: (node: AreaNode) => void;
}

interface TState {
  data: AreaNode[];
  defaultExpandedKeys: any[];
  defaultSelectedKeys: any[];
}

export class AreaTree extends React.PureComponent<TProps, TState> {
  constructor(props) {
    super(props);
    const keys = props.keys;
    this.state = {
      data: [],
      defaultExpandedKeys: keys,
      defaultSelectedKeys: keys
    };
  }

  onExpand(expandedKeys) {
    console.log("onExpand", expandedKeys, arguments);
  }

  onSelect(selectedKeys, info) {
    // console.log('selected', selectedKeys, info);
    // this.selKey = info.node.props.eventKey;
    this.props.onSelectionChange(info.node.props.item);
  }

  onCheck(checkedKeys, info) {
    console.log("onCheck", checkedKeys, info);
  }

  onEdit() {
    setTimeout(() => {
      // console.log('current key: ', this.selKey);
    }, 0);
  }

  onDel(e) {
    if (!window.confirm("sure to delete?")) {
      return;
    }
    e.stopPropagation();
  }

  render() {
    const loop = (data: AreaNode[]) => {
      const m = data.map(item => {
        if (item.children) {
          return (
            <TreeNode key={item.id} title={item.text} item={item}>
              {loop(item.children)}
            </TreeNode>
          );
        }
        return <TreeNode key={item.id} title={item.text} item={item} />;
      });
      return m;
    };

    return (
      <div className="area-tree">
        <Tree
          onSelect={this.onSelect.bind(this)}
          defaultExpandAll={true}
          showIcon={false}
          showLine={true}
        >
          {loop(this.props.data || [])}
        </Tree>
      </div>
    );
  }
}
